module.exports = __webpack_public_path__ + "img/app-jianzhu.a9f6b236.jpg";